module.exports = __webpack_public_path__ + "img/Picture5.59ed7bb1.png";